
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/network-operator-standards",
      function () {
        return require("private-next-pages/network-operator-standards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/network-operator-standards"])
      });
    }
  